export default "__VITE_ASSET__CNvTXxEM__"